import { Component, EventEmitter, Input, Output, ViewChild, QueryList } from '@angular/core';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { getObjectId } from 'src/app/shared/helpers/object.helper';

@Component({
    selector: 'upgrade-notice',
    templateUrl: './upgrade-notice.component.html',
    styleUrl: './upgrade-notice.component.scss',
    standalone: false
})
export class UpgradeNoticeComponent {

  static hidePopovers(notices?: QueryList<UpgradeNoticeComponent>) {
    if (notices) {
      notices.forEach((notice) => {
        notice.popover.onShown.subscribe(() => {
          notices.filter(n => n !== notice).forEach(n => n.popover.hide());
        });
      });
    }
  }

  @Input() feature: string;
  @Input() overlay: boolean = false;
  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('popoverDirective') popover: PopoverDirective;

  private _tooltipId: string;

  get requiredPlan() {
    return this.featuresService.featureRequiresEnterprise(this.feature) ?
      this.companyStateService.isK12Customer() ?
        'Unlimited'
      : 'Enterprise'
    : 'Advanced';
  }

  constructor(
    private companyStateService: CompanyStateService,
    public featuresService: FeaturesService
  ) {}

  getTooltipId() {
    if (!this._tooltipId) {
      this._tooltipId = `tooltip-upgrade-plan-${getObjectId({})}`;
    }
    return this._tooltipId;
  }

  showUpgradeModal() {
    this.featuresService.showUpgradePlanModal(this.feature).then((result) => {
      if (result) {
        this.closeEvent.emit();
      }
    });
  }
}
